import Competencies from "./Competencies";
import BaseApi from "../../BaseApi";


export default class PersonalCompetencies extends Competencies {
    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1")
            + "assessment-models/personal-competencies";
    }
}
